import React from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Input,
  Collapse,
  Form,
  Label,
} from "reactstrap";
import InputText from "../InputText";

import CustomButton from "../CustomButton";
import get from "lodash/get";

const _ = { get };

function filterCard(props) {
  let { elements } = props;
  return (
    <React.Fragment>
      <Collapse isOpen={props.toggleActive}>
        <Form onSubmit={props.handleSubmitFilter}>
          <Card className="mb-3">
            <CardBody>
              <Row>
                <Col xl={4} lg={4} md={6} sm={6}>
                  <FormGroup className=" confirmRiderSelect select_options">
                    {props.accessibleCountries &&
                    props.accessibleCountries.length === 1 &&
                    props.accessibleCountries[0] !== "*" ? (
                      <Input
                        type="select"
                        name="City"
                        className="w-100 customeSelectBtn"
                        onChange={props.handleCountryChange}
                        value={props.value.parsedCountry}
                      >
                        {props.countryList &&
                          props.countryList.length > 0 &&
                          props.countryList
                            .sort((a, b) =>
                              a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                            )
                            .map((item, index) => (
                              <option key={index} value={JSON.stringify(item)}>
                                {item.country}
                              </option>
                            ))}
                      </Input>
                    ) : (
                      <Input
                        type="select"
                        name="City"
                        className="w-100 customeSelectBtn"
                        onChange={props.handleCountryChange}
                        value={props.value.parsedCountry}
                      >
                        <option value="">
                          {_.get(
                            elements,
                            "branchListingFilterElements.CountryLabel",
                            "All Countries"
                          )}
                        </option>
                        {props.countryList &&
                          props.countryList.length > 0 &&
                          props.countryList
                            .sort((a, b) =>
                              a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                            )
                            .map((item, index) => (
                              <option key={index} value={JSON.stringify(item)}>
                                {item.country}
                              </option>
                            ))}
                      </Input>
                    )}
                  </FormGroup>
                </Col>
                <Col xl={4} lg={4} md={6} sm={6}>
                  <FormGroup className=" confirmRiderSelect select_options">
                    <Input
                      type="select"
                      name="branchType"
                      className="w-100 customeSelectBtn"
                      onChange={props.handleStateChange}
                      value={props.value.state}
                    >
                      <option>
                        {props.value.state !== ""
                          ? props.value.state
                          : _.get(
                              elements,
                              "branchListingFilterElements.selectStateLabel",
                              "Select State"
                            )}
                      </option>
                      {props.states
                        .sort((a, b) =>
                          a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                        )
                        .map((item, index) => (
                          <option key={index} value={JSON.stringify(item)}>
                            {item}
                          </option>
                        ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col xl={4} lg={4} md={6} sm={6}>
                  <FormGroup className=" confirmRiderSelect select_options">
                    <Input
                      type="select"
                      name="branchType"
                      className="w-100 customeSelectBtn"
                      onChange={props.handleCityChange}
                      value={props.value.city}
                    >
                      <option>
                        {props.value.city !== ""
                          ? props.value.city
                          : _.get(
                              elements,
                              "branchListingFilterElements.selectCityLabel",
                              "Select City"
                            )}
                      </option>
                      {props.cities
                        .sort((a, b) =>
                          a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                        )
                        .map((item, index) => (
                          <option key={index} value={JSON.stringify(item)}>
                            {item}
                          </option>
                        ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xl={4} lg={4} md={6} sm={6}>
                  <InputText
                    labelName={_.get(
                      elements,
                      "branchListingFilterElements.branchIdLabel",
                      "Branch Id"
                    )}
                    inputType={"text"}
                    inputName={"dealerId"}
                    InputClass={"inputText"}
                    customValue={props.value.dealerId}
                    inputPlaceholder={_.get(
                      elements,
                      "branchListingFilterElements.branchIdPlaceholder",
                      "Branch Id"
                    )}
                    customOnChange={(e) => props.handleFilterChange(e)}
                  />
                </Col>
                <Col xl={4} lg={4} md={6} sm={6}>
                  <InputText
                    labelName={_.get(
                      elements,
                      "branchListingFilterElements.emailLabel",
                      "Email"
                    )}
                    inputType={"email"}
                    inputName={"dealerEmail"}
                    InputClass={"inputText"}
                    customValue={props.value.dealerEmail}
                    inputPlaceholder={_.get(
                      elements,
                      "branchListingFilterElements.emailPlaceholder",
                      "Email"
                    )}
                    customOnChange={(e) => props.handleFilterChange(e)}
                  />
                </Col>
                <Col xl={4} lg={4} md={6} sm={6}>
                  <InputText
                    labelName={_.get(
                      elements,
                      "branchListingFilterElements.mobileLabel",
                      "Phone"
                    )}
                    inputType={"text"}
                    inputName={"dealerPhone"}
                    customValue={props.value.dealerPhone}
                    InputClass={"inputText"}
                    inputPlaceholder={_.get(
                      elements,
                      "branchListingFilterElements.mobilePlaceholder",
                      "Phone"
                    )}
                    customOnChange={(e) => props.handleFilterChange(e)}
                  />
                </Col>
              </Row>
              <Row>
                <Col xl={4} lg={4} md={6} sm={6} className="mb-3 mb-lg-0">
                  <Label className="inputLabel">
                    {_.get(
                      elements,
                      "branchListingFilterElements.statusLabel",
                      "Status"
                    )}
                  </Label>
                  <FormGroup className=" confirmRiderSelect select_options">
                    <Input
                      type="select"
                      name="status"
                      className="w-100 customeSelectBtn"
                      onChange={props.handleChangeStatus}
                      value={props.value.status}
                    >
                      <option value={"APPROVED"}>
                        {_.get(
                          elements,
                          "branchListingFilterElements.approvedElement",
                          "Approved"
                        )}
                      </option>
                      <option value={"PENDING"}>
                        {_.get(
                          elements,
                          "branchListingFilterElements.pendingElement",
                          "Pending"
                        )}
                      </option>
                      <option value={"REJECTED"}>
                        {_.get(
                          elements,
                          "branchListingFilterElements.rejectedElement",
                          "Rejected"
                        )}
                      </option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                <CustomButton
                  customType={"submit"}
                  name={_.get(
                    elements,
                    "branchListingFilterElements.searchButtonElement",
                    "Search"
                  )}
                  customClass={"btn-outline-dark bg-none btnthemeColor"}
                  customDisable={
                    props.value.countryCode !== "" ||
                    props.value.state !== "" ||
                    props.value.city !== "" ||
                    props.value.dealerEmail !== "" ||
                    props.value.dealerPhone !== "" ||
                    props.value.dealerId !== "" ||
                    props.value.status !== ""
                      ? false
                      : true
                  }
                />
                <CustomButton
                  customType={"button"}
                  name={_.get(
                    elements,
                    "branchListingFilterElements.clearFilterButtonElement",
                    "Clear Filter"
                  )}
                  customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                  customDisable={
                    props.value.countryCode !== "" ||
                    props.value.state !== "" ||
                    props.value.city !== "" ||
                    props.value.dealerEmail !== "" ||
                    props.value.dealerPhone !== "" ||
                    props.value.dealerId !== "" ||
                    props.value.status !== " "
                      ? false
                      : true
                  }
                  customClick={() => props.handleClearFilter()}
                />
              </div>
            </CardBody>
          </Card>
        </Form>
      </Collapse>
    </React.Fragment>
  );
}

export default filterCard;
